// extracted by mini-css-extract-plugin
module.exports = {"container":"CardSection_container__8Dm4n","statusContainer":"CardSection_statusContainer__i4tHd"};